<div class="custella-modal">
    
         <div class="custella-modal-header align-items-center">
            <div class="custella-modal-header-text">{{header | titlecase}} {{translate?.report.label.singular}}</div>
            <i class="pi pi-times" [pTooltip]="translate?.general?.buttons?.close.singular" tooltipPosition="left" (click)="modalRef.hide()"></i>
        </div>

        <div class="custella-modal-body">
            <div class="custella-form-container position-relative d-block w-100 rounded-2 box-none m-0" >
                <form [formGroup]="reportForm">
                    <div class="section-title mt-0">
                         <span class="bullet-container"><span class="font-white fa-sm number-bullet">1</span></span>
                        <h5 class="font-bold mt-2 bullet-label mandatory">{{title}}</h5>
                    </div>
                    <p class="mb-1">{{translate?.report.messages.fieldsAvailableInThe}} {{translate?.report.label.singular}} {{translate?.report.messages.willBeBasedSelection}}</p>
                    <p *ngIf="header == 'rename'">{{translate?.report.messages.folderCurrentlyIn}} {{currentFolder}}</p>
                    <div>
                        <p-dropdown
                            class="pe-2"
                            id="picklist_moduleReport"
                            [options]="moduleList"
                            optionLabel="datasetName"
                            filterBy="datasetName"
                            optionValue="datasetName"
                            placeholder="{{translate?.report.messages.selectModuleUsedIn}} {{translate?.report.label.singular}}..."
                            [filter]="true"
                            [showClear]="true"
                            (onHide)="onDropdownHide(datasetDD)"
                            #datasetDD
                            formControlName="name"
                        >
                        </p-dropdown>

                        <div class="p-error text-10 mt-1" *ngIf="reportForm.controls['name'].touched && reportForm.controls['name'].invalid">
                            <span *ngIf="reportForm.controls['name'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                        </div>
                    </div>

                    <div class="section-title mt-3">
                        <span class="bullet-container"><span class="font-white fa-sm number-bullet">2</span></span>
                        <h5 class="font-bold mt-2 bullet-label">{{translate?.report.messages.doYouWantThis}} {{translate?.report.label.singular}} {{translate?.report.messages.aggregatedFields}}</h5>
                        <i class="fa-regular fa-info-circle fa-sm" pTooltip="{{translate?.report.messages.ifSelectedAggregate}} {{translate?.report.label.singular}}. {{translate?.report.messages.aggregateFieldsCalculated}}"></i>
                        <p-inputSwitch formControlName="aggregated" [styleClass]="'mt-10px'" id="aggregateSwitch"></p-inputSwitch>
                    </div>
                 </form>
            </div>
            
        </div>

        <div class="custella-modal-footer flex-align-center justify-content-end gap-2">
            <button class="custella-btn-white" (click)="onCancelClick()">{{cancelButtonLabel}}</button>
            <p-button [label]="buttonLabel" [disabled]="reportForm.invalid" styleClass="h-32" id="btn_Next" (onClick)="onClickNext()"></p-button>

        </div>
</div>
